<template>
  <v-dialog v-model="internalDialog" content-class="dialog-fit-content">
    <v-card>
      <v-card-title class="headline">
        <span>
          Alterar status do sender
          <span v-if="sender">
            #{{ sender.id }}
            <span class="grey--text text--lighten">
              {{ formattedSenderPhone }}
            </span>
          </span>
        </span>
      </v-card-title>

      <v-card-text>
        <v-form ref="statusForm" v-model="formValid">
          <v-select
            :items="options"
            v-model="selectedStatus"
            label="Status"
            :rules="[statusRequired]"
            required
            box
            item-text="name"
            item-value="value"
            class="mb-1"
          >
            <template v-slot:item="{ item }">
              <v-icon left class="mr-2">{{ item.icon }}</v-icon>
              <span>{{ item.name }}</span>
            </template>
            <template v-slot:selection="{ item }">
              <v-icon left class="mr-2">{{ item.icon }}</v-icon>
              <span>{{ item.name }}</span>
            </template>
          </v-select>
          <v-textarea
            v-model="statusCause"
            label="Descrição"
            :counter="255"
            rows="2"
            auto-grow
            box
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider class="ma-0"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat dark @click="internalDialog = false">
          Cancelar
        </v-btn>
        <v-btn color="primary" dark @click="onConfirm"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    value: Boolean,
    sender: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formValid: false,
      selectedStatus: null,
      statusCause: "",
    };
  },
  computed: {
    formattedSenderPhone() {
      if (this.sender && this.sender.phone_number) {
        return this.$options.filters.phoneNumber(this.sender.phone_number);
      }
      return "";
    },
    internalDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.selectedStatus = this.sender ? this.sender.status : null;
        this.statusCause = this.sender ? this.sender.status_cause : "";
        this.$refs.statusForm.resetValidation();
      } else {
        this.selectedStatus = null;
        this.statusCause = "";
      }
    },
  },
  methods: {
    statusRequired(v) {
      return !!v || "Status é obrigatório";
    },
    onConfirm() {
      this.$emit("save", {
        status: this.selectedStatus,
        status_cause: this.statusCause ? this.statusCause.trim() : "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-fit-content {
  width: auto !important;
  max-width: 95vw !important;
  display: inline-table;
}
</style>
